import type { ComponentType, FC } from 'react'
import { useEffect } from 'react'

import { useAuth } from 'app/providers/auth/AuthProvider'

import { LOCALE_STORAGE_KEYS } from 'common/constants/localeStorageConstants'
import type { IUser } from 'common/interfaces/IUser'

const parseUser = (value: string | null): IUser | null => {
  try {
    return value ? JSON.parse(value) : null
  } catch {
    return null
  }
}

export const withLocalStorageMonitor = (Component: ComponentType) => {
  const WithLocalStorageMonitor: FC = (props) => {
    const { user } = useAuth()

    useEffect(() => {
      // Reload instead of logout(): logout() would revoke and clear the session another tab just created.
      const handleLocalStorageChange = (e: StorageEvent) => {
        if (e.key !== null && e.key !== LOCALE_STORAGE_KEYS.USER) return

        const newToken = e.key === null ? undefined : parseUser(e.newValue)?.access_token
        if (newToken !== user?.access_token) window.location.reload()
      }

      window.addEventListener('storage', handleLocalStorageChange)

      return () => {
        window.removeEventListener('storage', handleLocalStorageChange)
      }
    }, [user])

    return <Component {...props} />
  }

  return WithLocalStorageMonitor
}
